/* eslint-disable camelcase */
import { Money } from '@commercetools/platform-sdk';

import { fromNutsJson, NutsJson, webstore } from '@/api';

export interface GiftCertificateResponse {
  readonly code: string;
  readonly nonce: string;
  readonly initialValue: Money;
  readonly remainingValue: Money;
}

export async function getGiftCertificate(code: string) {
  const { data } = await fromNutsJson(
    webstore.get<NutsJson<GiftCertificateResponse>>(`/api/gift-certificates/${code}`),
  );
  return data;
}
